import Swal from 'sweetalert2';
const CallAPI = async (path, method = "get", body) => {
    const access_token = localStorage.getItem("access_token");
   
   try {
    console.log(`${process.env.REACT_APP_BASE_URL}${path}`,method)
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}${path}`, {
      method,
      headers: {
      "Content-Type": "application/json",
       "Access-Control-Allow-Origin": "*",
       Authorization: `Bearer ${access_token}`,
      },
  
      body: JSON.stringify(body)
    });
    if(!response.ok)
   {
    throw new Error(response)
   }
    const data = await  response.json();
      // const data=res.data;
    if(data.error){
        let error=new Error();
        error.status=data.status;
        error.message=data.message;
        throw error;
    }
    return data;
   } catch (error) {
    console.log(error);
    Swal.fire("Error",error.message,"error");
    throw error;
   }
  };
  

 export const CallAPIform = async (path, method = "get", form) => {
    const access_token = localStorage.getItem("access_token");
  
   try {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}${path}`, {
      method,
      headers: {
       "Access-Control-Allow-Origin": "*",
       Authorization: `Bearer ${access_token}`,
      },
  
      body: form
    });
    if(!response.ok)
   {
    throw new Error(response)
   }
    const data = await  response.json();
      // const data=res.data;
    if(data.error){
        let error=new Error();
        error.status=data.status;
        error.message=data.message;
        throw error;
    }
    return data;
   } catch (error) {
    console.log(error);
    Swal.fire("Error",error.message,"error");
    throw error;
   }
  };
  
  export default CallAPI;